export const planOptions = [25000, 50000, 100000, 200000];

export const sortedPlanOptions = (planOptions) => [...planOptions].sort((a, b) => {
    const priority = {
        "Essentials": 1,
        "Pro": 2,
        "Elite": 3
    };
    const getPriority = (name) => {
        if (!name) return 4; // Fallback for empty names
        if (name.includes("Essentials")) return priority["Essentials"];
        if (name.includes("Pro")) return priority["Pro"];
        if (name.includes("Elite")) return priority["Elite"];
        return 4; // Fallback for unknown plans (appear last)
    };
    return getPriority(a.name) - getPriority(b.name);
});
